<template>
    <div>
        {{ $t('unlock') }}
        <div class="sm:px-12 pt-20">
          <BigButton @clicked="$router.push({ name: 'select-tariff' })">
            {{ $t('tariffs') }}
          </BigButton>
        </div>
    </div>
</template>

<script>
import BigButton from '@/components/visual/BigButton'
export default {
  components: { BigButton },
}
</script>

<i18n locale="ru" lang="yaml">
  unlock: "Выберите тарифный план без ограничений, чтобы смотреть прогнозы на весь месяц и учитывать личную благоприятность."
  tariffs: "Тарифные планы"
</i18n>

<i18n locale="en" lang="yaml">
  unlock: ""
  tariffs: "Available plans"
</i18n>
